<ngx-spinner type="ball-clip-rotate"></ngx-spinner>

<ng-container *ngIf="initialized">
  <div *ngIf="page === 'login'">
    <app-sas-station-login></app-sas-station-login>
  </div>

  <div *ngIf="page === 'register'">
    <app-sas-station-register></app-sas-station-register>
  </div>

  <div *ngIf="page === 'forgot-password'">
    <app-sas-station-forgot-password></app-sas-station-forgot-password>
  </div>

  <!-- 送信しましたページ -->
  <div *ngIf="page === 'password-reset-send'">
    <app-sas-station-change-password-sent></app-sas-station-change-password-sent>
  </div>

  <app-sas-station-register-resend
    *ngIf="page === 'register-resend'"
  ></app-sas-station-register-resend>
</ng-container>
